<template>
  <div>
    <ed-campanha :intTipoServicoId="1410" :intId="$route.params.intId" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdCampanha from "@/components/campanha/editar";
export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdCampanha },
  mounted() {
    if(!this.$route.params.intId){
      this.$router.push({ name: "periodico.disparar" });
    }
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>